module.exports = __webpack_public_path__ + "components/flag/static/square/az-2b55720bac9fbdf9e8eb4c5882ade00e.svg";